import React, { Component } from 'react';

class Section extends Component {
    render() {
        return (
            <section className="mt-5">
                <h2 className="mb-3">{this.props.title}</h2>
                <div>{this.props.children}</div>
            </section>
        );
    }
}

export default Section;



// WEBPACK FOOTER //
// ./src/reference/ui/Section.js